export const CERTIFICATE_VIEW_ERROR_MESSAGE =
  'Não foi possível carregar o certificado. Tente novamente.';
